import PollBadgesValue from "./PollBadgesValue";
import PotmBadgesValue from "./PotmBadgesValue";

export default class VotingBadgesValue {
  public potm: PotmBadgesValue[] = [];
  public poll: PollBadgesValue[] = [];
}
